import { Loader2, ChevronDown } from "lucide-react";

export const PAGE_SIZE = 200;
export const totalFrom = (res) => Number(res.headers?.["x-total-count"] ?? res.data?.length ?? 0);

export function LoadMoreBar({ shown, total, loading, onMore, testid = "load-more" }) {
  if (!total || shown >= total) {
    return total > PAGE_SIZE ? <div className="py-3 text-center text-[11px] text-slate-400" data-testid={`${testid}-end`}>All {total.toLocaleString()} records loaded</div> : null;
  }
  return (
    <div className="flex flex-col items-center gap-1 py-4" data-testid={`${testid}-bar`}>
      <div className="text-[11px] text-slate-500">Showing {shown.toLocaleString()} of {total.toLocaleString()}</div>
      <button onClick={onMore} disabled={loading} data-testid={testid}
        className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-4 h-9 text-xs font-semibold text-slate-700 hover:bg-slate-100 disabled:opacity-60 transition">
        {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ChevronDown className="h-3.5 w-3.5" />} Load {Math.min(PAGE_SIZE, total - shown)} more
      </button>
    </div>
  );
}
